export default "__VITE_ASSET__074fb26b__"